if (!window.productCardSwatchesLoaded) {
  window.productCardSwatchesLoaded = true;

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-product-card-swatch]');

    if (!swatch) return;

    const card = swatch.closest('.product-card');
    const picture = card?.querySelector('.banner__image');
    const source = picture?.querySelector('source');
    const image = picture?.querySelector('img');
    const link = card?.querySelector('.stretched-link');
    const src = swatch.dataset.imageSrc;

    if (!card) return;

    event.preventDefault();
    event.stopPropagation();

    card.querySelectorAll('[data-product-card-swatch]').forEach((button) => {
      const isActive = button === swatch;

      button.classList.toggle('product-card__swatch--active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (picture && source && image && src) {
      source.srcset = swatch.dataset.imageSrcset || src;
      image.src = src;
      image.removeAttribute('srcset');
      image.alt = swatch.dataset.imageAlt || image.alt;

      if (swatch.dataset.imageWidth) image.width = swatch.dataset.imageWidth;
      if (swatch.dataset.imageHeight) image.height = swatch.dataset.imageHeight;
    }

    if (link && swatch.dataset.variantUrl) link.href = swatch.dataset.variantUrl;
  });
}
